import axios from 'axios'
import { useStore } from '../store/pinia'
import router from '@/router'
// import { Message } from '@element-plus/icons-vue'

const instance = axios.create({
  // baseURL: "",
  timeout: 60 * 1000, // 1 minute
  headers: {
    'X-Custom-Header': 'foobar',
    'x-requested-with': 'XMLHttpRequest'
  }
})
// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    // console.log('before---')
    const store = useStore()
    if (store.$state.token) {
      // 此处设置的headers token名称要与后端拦截器获取的header token名称一致
      config.headers['token'] = `${store.$state.token}`
    }
    return config
  },
  async function (error) {
    // 对请求错误做些什么
    console.log('error-----')
    // Message.error("sorry, it's error!")
    const r = await Promise.reject(error)
    return console.log(r)
  }
)

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    // console.log('res-before---')
    const result = response.data
    const errCode = result.code
    if (errCode !== undefined) {
      // 下面的代码是对常见错误进行用户提醒，根据业务逻辑具体修改
      // if (response.headers.updatetoken == "update") {
      //   store.UpdateToken();
      // }
      // if (errCode === 20001) {
      //   Message({
      //     message: "登录超时，请重新登录",
      //     type: "error",
      //     duration: 5 * 1000,
      //   });
      //   return Promise.reject(new Error("token expired"));
      // }
    }
    return response.data
  },
  function (error) {
    // 对响应错误做点什么
    console.log('res-error---')
    return Promise.reject(error)
  }
)

export default instance



// WEBPACK FOOTER //
// ./src/utils/axios.js